<template>
  
  <div  class="rounded p-4">
    <p class="py-4">{{ $t('message.linkUser.description') }}</p>
    <div class="border p-4 px-6">

      <div class="w-full flex justify-around m-auto py-2">
        <div
        class="w-4/12 logo-company-change-box flex items-center justify-center pb-2"
        >
        <logo-company :user-id="parseInt(linkUserDataFormArray[step-1].companyId)"  :key="step" noSave />
      </div>
      <div class=" flex align-center justify-end text-right">
        <p>{{ linkUserDataFormArray[step-1].companyName }}</p>
      </div>
  
      </div>
      <zt-alert v-if="this.warning"  color="warning" >
        <template slot="custom-content">
          <div class="flex justify-start items-center">
            <zt-icon name="warning-triangle-solid" class="text-xl mr-4"></zt-icon>
            <p class="pr-4"> {{ warningMessage}}</p>
          </div>
        </template>
      </zt-alert>
      <zt-input disabled outlined name="typeAccount" class="w-full my-2" readonly v-model="user" :key="'id'+step"
        label="Usuario" data-vs-input="userInput" />
      <zt-input outlined name="typeAccount" class="w-full my-2" v-model="password"
        label="Contraseña" type="password" data-vs-input="passwordAccount" />
      
        <zt-button color="disabled" class="padding-left-0 text-zt-primary-100 pl-1" data-vs-button="cancel"  @click="noLinkAccountModalActive = !noLinkAccountModalActive">
          {{ $t('message.linkUser.notLinked') }}
        </zt-button>
      
    </div>
    <no-link-account-modal
    :noLinkAccountModalActive="noLinkAccountModalActive"
    :isMobile="isMobile"
    @update:noLinkAccountModalActive="noLinkAccountModalActive = $event"
    @notLinkAccount="handleNotLinkAccount"
    />
  </div>
</template>

<script>
import logoCompany from '@/components/commons/LogoCompany'
import NoLinkAccountModal from '../components/NoLinkAccountModal.vue';

export default {
  components: {
    logoCompany,
    NoLinkAccountModal
  },
  props: {
    linkUserDataFormArray: {
      type: Array,
      required: true,
      default: []
    },
    step: {
      type: Number,
      required: true
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    warning:{
      type: String,
      default: ''
    },
  },
  data() {
    return {
      password: '',
      noLinkAccountModalActive: false,
      accountsNotToLink: [],
      user: this.$store.state.user.usuario,
    }
  },
  methods: {
    handleNotLinkAccount(reasons) {
      this.$emit('notLinkAccount', this.linkUserDataFormArray[this.step-1].userId, reasons)
      this.noLinkAccountModalActive = false
   
    }
  },
  computed: {
   warningMessage() {
      return  this.warning ? this.$t(`message.errorReference.${this.warning}`) : null
    },
}
}
</script>

<style lang="scss" scoped>
.logo-company-change-box{ 
  max-width: 100px;
}
.padding-left-0 {
  padding-left: 0 !important;
}
</style>